<template>
  <div class="flex flex-col gap-3">
    <div class="flex gap-2 items-end">
      <h1 class="font-bold text-3xl">{{ person.name }}</h1>
      <slot name="badges" />
    </div>
    <p class="text-muted-foreground text-sm">{{ subTitleAttributes }}</p>
    <div class="flex gap-3">
      <InAppCallModal :phone-number="person.phone" :contact-name="person.name" :contact-id="person.id">
        <template #default="{ open }">
          <Button data-track="clicked-call-person-button" variant="outline" class="cursor-pointer group" @click="open">
            <vue-feather type="phone" class="icon" />
            Call
          </Button>
        </template>
      </InAppCallModal>
      <Button data-track="clicked-chat-person-button" variant="outline" class="cursor-pointer group" @click="openChat">
        <vue-feather type="message-circle" class="icon" />
        Message
      </Button>
      <Button
        data-track="clicked-email-person-button"
        variant="outline"
        class="cursor-pointer group"
        @click="openEmail"
      >
        <vue-feather type="mail" class="icon" />
        Email
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Person } from '../Person';
import { Button } from '@/components/ui/button';
import InAppCallModal from '@/components/shared/InAppCallModal.vue';
import { useMultiChatStore } from '@/components/shared/MultiChat';
import { useMultiEmailStore } from '@/components/shared/MultiEmail';

const props = defineProps<{
  person: Person;
}>();

const chatStore = useMultiChatStore();
const emailStore = useMultiEmailStore();

const subTitleAttributes = computed(() => {
  const license = props.person.license ? `License #${props.person.license}` : null;
  const phoneNumber = props.person.phone?.replace('+1 ', '');
  const list = [phoneNumber, props.person.email, license].filter(x => x !== null);
  return list.join(' • ');
});

const openChat = () => {
  chatStore.openChat({
    id: props.person.id,
    name: props.person.name,
    canReceiveSms: props.person.canReceiveSms,
  });
};

const openEmail = () => {
  emailStore.openEmail({
    contactId: props.person.id,
    contactName: props.person.name,
    contactEmail: props.person.email,
  });
};
</script>

<style scoped>
@reference "tailwindcss";

.icon {
  @apply h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500;
}
</style>
